export enum ExperienceTagType {
  Skill = 'SKILL',
  Industry = 'INDUSTRY',
  CompanySize = 'COMPANY_SIZE',
}
